import { useLayoutEffect, useState } from 'react';
import { useQuill } from '../editor/QuillContext';
import type { DocumentType } from '../graphql/generated';
import { gql } from '../graphql/generated';
import { getMagneticWallItemElementsWithIds } from './MagneticWall';

const POST_FRAGMENT = gql(`
    fragment useHasMagneticWallItems_post on PublicPostFields {
        id
        threads {
            id
        }
        annotations {
            id
        }
    }
`);

const useHasMagneticWallItems = (
  post: DocumentType<typeof POST_FRAGMENT> | undefined,
) => {
  const { quill } = useQuill();

  const [hasMagneticWallItems, setHasMagneticWallItems] = useState(false);

  useLayoutEffect(() => {
    const hasThreadsOrAnnotations =
      (!!post?.threads && post.threads.length > 0) ||
      (!!post?.annotations && post.annotations.length > 0);

    const hasElements =
      quill && hasThreadsOrAnnotations
        ? getMagneticWallItemElementsWithIds(quill.container).length > 0
        : false;

    setHasMagneticWallItems(hasElements);
  }, [quill, post?.threads, post?.annotations]);

  return hasMagneticWallItems;
};

export default useHasMagneticWallItems;
